import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { listBookAuthorsQueryKey } from "@modules/bookAuthors/services/queries";
import { useCreateBookAuthorMutation } from "@modules/bookAuthors/services/mutations";
import { BookAuthorFormValues, bookAuthorSchema } from "@modules/bookAuthors/validations";

export function useCreateBookAuthorModal(modalRef: RefObject<ModalRef>, onComplete: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<BookAuthorFormValues>({
    resolver: zodResolver(bookAuthorSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateBookAuthorMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listBookAuthorsQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("book_contributor_admin.success.create"),
      });

      onComplete();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
